module.exports = __webpack_public_path__ + "media/images/iconSocialX__inactive--dark-559bc0375d3e0b48233a905ef777ff2f.png";